var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-slick/~/react-responsive-mixin/~/can-use-dom/index.js
 ** module id = 552
 ** module chunks = 0
 **/